import React from 'react';

interface PercentBarProps {
  percent: number;      // 0-100
  showLabel?: boolean;  // Whether to show percentage text
  size?: 'sm' | 'md';   // Size variant
  className?: string;
}

export const PercentBar: React.FC<PercentBarProps> = ({
  percent,
  showLabel = true,
  size = 'sm',
  className = '',
}) => {
  const clampedPercent = Math.min(100, Math.max(0, percent));
  const height = size === 'sm' ? 'h-1.5' : 'h-2.5';

  // Color based on percentage
  const getColor = (p: number) => {
    if (p < 50) return 'bg-blue-500';
    if (p < 80) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <div className={`flex-1 ${height} bg-white/10 rounded-full overflow-hidden min-w-[40px]`}>
        <div
          className={`${height} ${getColor(clampedPercent)} rounded-full transition-all duration-300`}
          style={{ width: `${clampedPercent}%` }}
        />
      </div>
      {showLabel && (
        <span className="text-[10px] text-white/50 min-w-[32px] text-right tabular-nums">
          {clampedPercent.toFixed(1)}%
        </span>
      )}
    </div>
  );
};

export default PercentBar;
